// node modules
import React, { memo } from 'react';
import { Route } from 'react-router-dom';
import { ErrorBoundary } from 'react-error-boundary';
// modules
import { FullScreenLayout, InitProvider } from 'modules/App';
import { AuthorizedRouter } from 'modules/Routing';
import { WsProvider } from 'modules/WebSocket';
// components
import { MainChart } from 'modules/TradingChart';
import Loader from 'modules/TradesPW3/Orders/Loader';
import { MainLayout } from 'app/components/MainLayout/MainLayout';
import ErrorHandler from './errorHandler';
// routes
import { AUTHORIZED_ROUTES } from './registration';

export const AuthorizedRoutes = memo(() => {
  const renderFallback = () => <Loader />;

  return (
    <ErrorBoundary
      fallbackRender={renderFallback}
      onError={ErrorHandler}
    >
      <InitProvider>
        <WsProvider live portfolioV2>
          <MainLayout>
            <FullScreenLayout>
              <Route
                exact
                path={AUTHORIZED_ROUTES.CHARTS}
                component={MainChart}
              />
            </FullScreenLayout>
          </MainLayout>
        </WsProvider>
      </InitProvider>
    </ErrorBoundary>
  );
});

export const Router = memo(() => (
  <AuthorizedRouter
    appRoutes={{
      paths: Object.values(AUTHORIZED_ROUTES),
      rootPath: AUTHORIZED_ROUTES.DEFAULT_CHART,
      component: AuthorizedRoutes,
    }}
  />
));
